import { render, staticRenderFns } from "./staffbreakhrspopover_component.vue?vue&type=template&id=7e3b290b&scoped=true&"
import script from "../assets/js/addBreakComponent.js?vue&type=script&lang=js&"
export * from "../assets/js/addBreakComponent.js?vue&type=script&lang=js&"
import style0 from "./staffbreakhrspopover_component.vue?vue&type=style&index=0&id=7e3b290b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3b290b",
  null
  
)

export default component.exports